export default __webpack_public_path__ + "static/media/68952-blast-new.861722d3.gif";